interface StepIndicatorProps {
  currentStep: number;
  steps?: Array<{
    number: number;
    title: string;
    description: string;
  }>;
}

export default function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  const defaultSteps = [
    { number: 1, title: 'Cadastro', description: 'Cadastre colaboradores' },
    { number: 2, title: 'Resumo', description: 'Confirme os dados' },
    { number: 3, title: 'Finalizado', description: 'Agendamento concluído' }
  ];

  const stepList = steps || defaultSteps;

  return (
    <div className="bg-white rounded-xl shadow-lg border border-green-100 p-8 mb-8">
      <div className="flex items-center justify-between">
        {stepList.map((step, index) => {
          const isCompleted = step.number < currentStep;
          const isCurrent = step.number === currentStep;
          const isUpcoming = step.number > currentStep;

          return (
            <div key={step.number} className="flex items-center flex-1">
              {/* Círculo do passo */}
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-lg ${
                    isCompleted
                      ? 'bg-green-600 text-white'
                      : isCurrent
                        ? 'bg-green-600 text-white ring-4 ring-green-200'
                        : 'bg-gray-200 text-gray-400'
                  }`}>
                  {isCompleted ? (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    step.number
                  )}
                </div>

                {/* Título e descrição */}
                <div className="mt-3 text-center max-w-32">
                  <span className={`text-sm font-medium uppercase tracking-wide ${
                    isCompleted 
                      ? 'text-gray-900' 
                      : isCurrent 
                        ? 'text-green-600 font-bold' 
                        : 'text-gray-400'
                    }`}>
                    {step.title}
                  </span>
                  <p className={`text-xs mt-1 ${
                    isCompleted 
                      ? 'text-gray-600' 
                      : isCurrent 
                        ? 'text-green-600' 
                        : 'text-gray-400'
                  }`}>
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Linha conectora */}
              {index < stepList.length - 1 && (
                <div className={`flex-1 h-1 mx-4 rounded ${isCompleted ? 'bg-green-600' : 'bg-gray-200'
                  }`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}


